import { render, staticRenderFns } from "./ChickDepurationRequestModal.vue?vue&type=template&id=75661149&scoped=true"
import script from "./ChickDepurationRequestModal.vue?vue&type=script&lang=js"
export * from "./ChickDepurationRequestModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75661149",
  null
  
)

export default component.exports